var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "available-schedule" },
    [
      _c("div", { staticClass: "schedule-header" }, [
        _c("div", [
          _c("h5", { staticClass: "schedule-title" }, [
            _vm._v(_vm._s(_vm.$t("schedule.grid.title"))),
          ]),
          _c("p", { staticClass: "schedule-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("schedule.grid.subtitle"))),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "schedule-header-actions" },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "outline-primary", size: "sm" },
                on: {
                  click: function ($event) {
                    return _vm.addRow()
                  },
                },
              },
              [
                _c("feather-icon", {
                  staticClass: "mr-50",
                  attrs: { icon: "PlusIcon", size: "16" },
                }),
                _c("span", { staticClass: "align-middle" }, [
                  _vm._v(_vm._s(_vm.$t("schedule.grid.add_row"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.isRowEmpty
        ? _c(
            "div",
            { staticClass: "schedule-empty" },
            [
              _c("feather-icon", {
                staticClass: "text-primary mb-1",
                attrs: { icon: "CalendarIcon", size: "28" },
              }),
              _c("p", { staticClass: "schedule-empty-title" }, [
                _vm._v(_vm._s(_vm.$t("schedule.grid.empty_title"))),
              ]),
              _c("p", { staticClass: "schedule-empty-hint" }, [
                _vm._v(_vm._s(_vm.$t("schedule.grid.empty_hint"))),
              ]),
              _c(
                "b-button",
                {
                  staticClass: "mt-1",
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.addRow()
                    },
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "PlusIcon", size: "16" },
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("schedule.grid.add_row"))),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c("div", { staticClass: "schedule-scroll" }, [
            _c(
              "div",
              { staticClass: "schedule-table" },
              [
                _c(
                  "div",
                  { staticClass: "schedule-row schedule-row-head" },
                  [
                    _c("div", { staticClass: "schedule-legend" }),
                    _vm._l(_vm.weekDays, function (day) {
                      return _c(
                        "div",
                        {
                          key: "head-" + day,
                          staticClass: "schedule-cell schedule-head-cell",
                          class: { "is-weekend": _vm.isWeekend(day) },
                        },
                        [
                          _c("span", { staticClass: "head-short" }, [
                            _vm._v(_vm._s(_vm.dayShort(day))),
                          ]),
                          _c("span", { staticClass: "head-count" }, [
                            _vm._v(_vm._s(_vm.dayCountLabel(day))),
                          ]),
                        ]
                      )
                    }),
                    _c("div", { staticClass: "schedule-total-col" }, [
                      _vm._v(_vm._s(_vm.$t("schedule.weekly_total"))),
                    ]),
                    _c("div", { staticClass: "schedule-actions-col" }, [
                      _vm._v(_vm._s(_vm.$t("actions"))),
                    ]),
                  ],
                  2
                ),
                _vm._l(_vm.dataRows, function (row, rowIndex) {
                  return _c(
                    "div",
                    {
                      key: row.uid,
                      staticClass: "schedule-row schedule-row-body",
                    },
                    [
                      _c("div", { staticClass: "schedule-legend" }, [
                        _c("span", { staticClass: "legend-item" }, [
                          _vm._v(_vm._s(_vm.$t("schedule.grid.start"))),
                        ]),
                        _c("span", { staticClass: "legend-item" }, [
                          _vm._v(_vm._s(_vm.$t("schedule.grid.end"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.capacityHint,
                                  delay: { show: 300, hide: 100 },
                                },
                                expression:
                                  "{ content: capacityHint, delay: { show: 300, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "legend-item legend-capacity",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("schedule.grid.capacity_label")) +
                                " "
                            ),
                            _c("feather-icon", {
                              attrs: { icon: "HelpCircleIcon", size: "12" },
                            }),
                          ],
                          1
                        ),
                        _c("span", { staticClass: "legend-meta" }),
                      ]),
                      _vm._l(_vm.weekDays, function (day) {
                        return _c(
                          "div",
                          {
                            key: row.uid + "-" + day,
                            staticClass: "schedule-cell",
                            class: {
                              "is-weekend": _vm.isWeekend(day),
                              "has-error": _vm.cellHasError(rowIndex, day),
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: row.days[day].start,
                                  expression: "row.days[day].start",
                                },
                              ],
                              staticClass: "cell-input",
                              class: _vm.inputClass(rowIndex, day, "start"),
                              attrs: {
                                type: "time",
                                "aria-label":
                                  _vm.$t("schedule.grid.start") +
                                  " — " +
                                  _vm.dayLong(day),
                              },
                              domProps: { value: row.days[day].start },
                              on: {
                                change: function ($event) {
                                  return _vm.onStartChange(row, day)
                                },
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.focusNextField($event)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    row.days[day],
                                    "start",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: row.days[day].end,
                                  expression: "row.days[day].end",
                                },
                              ],
                              staticClass: "cell-input",
                              class: _vm.inputClass(rowIndex, day, "end"),
                              attrs: {
                                type: "time",
                                "aria-label":
                                  _vm.$t("schedule.grid.end") +
                                  " — " +
                                  _vm.dayLong(day),
                              },
                              domProps: { value: row.days[day].end },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.focusNextField($event)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    row.days[day],
                                    "end",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: row.days[day].capacity,
                                  expression: "row.days[day].capacity",
                                },
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.auto",
                                  value: {
                                    content: _vm.capacityHint,
                                    delay: { show: 500, hide: 100 },
                                  },
                                  expression:
                                    "{ content: capacityHint, delay: { show: 500, hide: 100 } }",
                                  modifiers: { auto: true },
                                },
                              ],
                              staticClass: "cell-input cell-capacity",
                              class: _vm.inputClass(rowIndex, day, "capacity"),
                              attrs: {
                                type: "number",
                                min: "1",
                                max: "999",
                                step: "1",
                                placeholder: _vm.capacityPlaceholder,
                                "aria-label":
                                  _vm.$t("schedule.grid.capacity_label") +
                                  " — " +
                                  _vm.dayLong(day),
                              },
                              domProps: { value: row.days[day].capacity },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    row.days[day],
                                    "capacity",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "cell-meta",
                                class: {
                                  "is-warning": _vm.cellWarning(rowIndex, day),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.cellMeta(rowIndex, day)) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      _c("div", { staticClass: "schedule-total-col" }, [
                        _c("span", { staticClass: "row-total" }, [
                          _vm._v(_vm._s(_vm.rowTotals[rowIndex])),
                        ]),
                        _c("span", { staticClass: "row-days" }, [
                          _vm._v(_vm._s(_vm.rowDaysLabel(rowIndex))),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "schedule-actions-col" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.$t("schedule.grid.replicate"),
                                  delay: { show: 300, hide: 100 },
                                },
                                expression:
                                  "{ content: $t('schedule.grid.replicate'), delay: { show: 300, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "cursor-pointer text-primary",
                            attrs: { icon: "CopyIcon", size: "20" },
                            on: {
                              click: function ($event) {
                                return _vm.openReplicate(rowIndex)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.$t(
                                    "schedule.grid.duplicate_row"
                                  ),
                                  delay: { show: 300, hide: 100 },
                                },
                                expression:
                                  "{ content: $t('schedule.grid.duplicate_row'), delay: { show: 300, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "cursor-pointer text-primary",
                            attrs: { icon: "LayersIcon", size: "20" },
                            on: {
                              click: function ($event) {
                                return _vm.duplicateRow(rowIndex)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.$t("schedule.grid.remove_row"),
                                  delay: { show: 300, hide: 100 },
                                },
                                expression:
                                  "{ content: $t('schedule.grid.remove_row'), delay: { show: 300, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "cursor-pointer text-danger",
                            attrs: { icon: "Trash2Icon", size: "20" },
                            on: {
                              click: function ($event) {
                                return _vm.confirmRemoveRow(rowIndex)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "schedule-row-window" },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-25 text-muted",
                            attrs: { icon: "CalendarIcon", size: "13" },
                          }),
                          _c("span", { staticClass: "window-label" }, [
                            _vm._v(_vm._s(_vm.$t("schedule.window.label"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: row.startsOn,
                                expression: "row.startsOn",
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.$t(
                                    "schedule.window.starts_on_hint"
                                  ),
                                  delay: { show: 400, hide: 100 },
                                },
                                expression:
                                  "{ content: $t('schedule.window.starts_on_hint'), delay: { show: 400, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "window-input",
                            attrs: {
                              type: "date",
                              "aria-label": _vm.$t("schedule.window.starts_on"),
                            },
                            domProps: { value: row.startsOn },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(row, "startsOn", $event.target.value)
                              },
                            },
                          }),
                          _c("span", { staticClass: "window-sep" }, [
                            _vm._v(_vm._s(_vm.$t("schedule.window.until"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: row.endsOn,
                                expression: "row.endsOn",
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.$t(
                                    "schedule.window.ends_on_hint"
                                  ),
                                  delay: { show: 400, hide: 100 },
                                },
                                expression:
                                  "{ content: $t('schedule.window.ends_on_hint'), delay: { show: 400, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "window-input",
                            attrs: {
                              type: "date",
                              min: row.startsOn || null,
                              "aria-label": _vm.$t("schedule.window.ends_on"),
                            },
                            domProps: { value: row.endsOn },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(row, "endsOn", $event.target.value)
                              },
                            },
                          }),
                          !row.startsOn && !row.endsOn
                            ? _c("span", { staticClass: "window-hint" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("schedule.window.forever")) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.rowMessages(rowIndex).length
                        ? _c(
                            "ul",
                            { staticClass: "schedule-row-messages" },
                            _vm._l(
                              _vm.rowMessages(rowIndex),
                              function (message, index) {
                                return _c(
                                  "li",
                                  {
                                    key: "msg-" + row.uid + "-" + index,
                                    class:
                                      message.type === "error"
                                        ? "is-error"
                                        : "is-warning",
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-25",
                                      attrs: {
                                        icon:
                                          message.type === "error"
                                            ? "AlertCircleIcon"
                                            : "AlertTriangleIcon",
                                        size: "13",
                                      },
                                    }),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.dayShort(message.day)) + ":"
                                      ),
                                    ]),
                                    _vm._v(" " + _vm._s(message.text) + " "),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                _c(
                  "div",
                  { staticClass: "schedule-row schedule-row-foot" },
                  [
                    _c("div", { staticClass: "schedule-legend" }, [
                      _vm._v(_vm._s(_vm.$t("schedule.day_total"))),
                    ]),
                    _vm._l(_vm.weekDays, function (day) {
                      return _c(
                        "div",
                        {
                          key: "foot-" + day,
                          staticClass: "schedule-cell schedule-foot-cell",
                          class: { "is-weekend": _vm.isWeekend(day) },
                        },
                        [_vm._v(" " + _vm._s(_vm.dayTotals[day]) + " ")]
                      )
                    }),
                    _c("div", { staticClass: "schedule-total-col" }, [
                      _vm._v(_vm._s(_vm.grandTotal)),
                    ]),
                    _c("div", { staticClass: "schedule-actions-col" }),
                  ],
                  2
                ),
              ],
              2
            ),
          ]),
      _c("div", { staticClass: "dates-section" }, [
        _c("div", { staticClass: "schedule-header" }, [
          _c("div", [
            _c("h5", { staticClass: "schedule-title" }, [
              _vm._v(_vm._s(_vm.$t("schedule.dates.title"))),
            ]),
            _c("p", { staticClass: "schedule-subtitle" }, [
              _vm._v(_vm._s(_vm.$t("schedule.dates.subtitle"))),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "schedule-header-actions" },
            [
              _vm.dateRows.length > 1 && _vm.firstFilledDatedRow
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-primary", size: "sm" },
                      on: { click: _vm.applyTimeToAllDates },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "CopyIcon", size: "16" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("schedule.dates.apply_all"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "dates-body" }, [
          _c("div", { staticClass: "dates-calendar" }, [
            _c(
              "div",
              { staticClass: "calendar-head" },
              [
                _c("feather-icon", {
                  staticClass: "cursor-pointer",
                  attrs: { icon: "ChevronLeftIcon", size: "18" },
                  on: {
                    click: function ($event) {
                      return _vm.shiftMonth(-1)
                    },
                  },
                }),
                _c("span", { staticClass: "calendar-label" }, [
                  _vm._v(_vm._s(_vm.calendarLabel)),
                ]),
                _c("feather-icon", {
                  staticClass: "cursor-pointer",
                  attrs: { icon: "ChevronRightIcon", size: "18" },
                  on: {
                    click: function ($event) {
                      return _vm.shiftMonth(1)
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "calendar-grid" },
              [
                _vm._l(_vm.weekDays, function (day) {
                  return _c(
                    "div",
                    { key: "cal-h-" + day, staticClass: "calendar-weekday" },
                    [_vm._v(" " + _vm._s(_vm.dayShort(day)) + " ")]
                  )
                }),
                _vm._l(_vm.calendarWeeks, function (week, weekIndex) {
                  return _vm._l(week, function (day, dayIndex) {
                    return _c(
                      "div",
                      {
                        key: "cal-" + weekIndex + "-" + dayIndex,
                        staticClass: "calendar-day",
                        class: {
                          "is-blank": day === null,
                          "is-past": _vm.isPastDate(day),
                          "is-selected":
                            day !== null &&
                            _vm.selectedDates[_vm.dateOfCell(day)],
                        },
                        on: {
                          click: function ($event) {
                            day !== null && _vm.toggleDate(day)
                          },
                        },
                      },
                      [
                        day !== null
                          ? _c("span", [_vm._v(_vm._s(day))])
                          : _vm._e(),
                        day !== null &&
                        _vm.selectedDates[_vm.dateOfCell(day)] > 1
                          ? _c("span", { staticClass: "calendar-day-count" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.selectedDates[_vm.dateOfCell(day)]
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  })
                }),
              ],
              2
            ),
            _c("p", { staticClass: "calendar-hint" }, [
              _vm._v(_vm._s(_vm.$t("schedule.dates.calendar_hint"))),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "dates-list" },
            [
              _vm.dateRows.length === 0
                ? _c(
                    "div",
                    { staticClass: "dates-empty" },
                    [
                      _c("feather-icon", {
                        staticClass: "text-primary mb-1",
                        attrs: { icon: "CalendarIcon", size: "24" },
                      }),
                      _c("p", { staticClass: "schedule-empty-title" }, [
                        _vm._v(_vm._s(_vm.$t("schedule.dates.empty_title"))),
                      ]),
                      _c("p", { staticClass: "schedule-empty-hint" }, [
                        _vm._v(_vm._s(_vm.$t("schedule.dates.empty_hint"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.dateRows, function (row, index) {
                return _c(
                  "div",
                  {
                    key: row.uid,
                    staticClass: "dates-row",
                    class: {
                      "has-error": _vm.dateValidation[index].errors.length > 0,
                    },
                  },
                  [
                    _c("div", { staticClass: "dates-row-date" }, [
                      _vm._v(_vm._s(_vm.formatDateLong(row.date))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "dates-row-fields" },
                      [
                        _c("label", { staticClass: "dates-field" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("schedule.grid.start"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: row.start,
                                expression: "row.start",
                              },
                            ],
                            class: _vm.datedInputClass(index, "start"),
                            attrs: { type: "time" },
                            domProps: { value: row.start },
                            on: {
                              change: function ($event) {
                                return _vm.onDatedStartChange(row)
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.focusNextField.apply(null, arguments)
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(row, "start", $event.target.value)
                              },
                            },
                          }),
                        ]),
                        _c("label", { staticClass: "dates-field" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("schedule.grid.end"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: row.end,
                                expression: "row.end",
                              },
                            ],
                            class: _vm.datedInputClass(index, "end"),
                            attrs: { type: "time" },
                            domProps: { value: row.end },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.focusNextField.apply(null, arguments)
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(row, "end", $event.target.value)
                              },
                            },
                          }),
                        ]),
                        _c("label", { staticClass: "dates-field" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("schedule.grid.capacity_short"))
                            ),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: row.capacity,
                                expression: "row.capacity",
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.capacityHint,
                                  delay: { show: 400, hide: 100 },
                                },
                                expression:
                                  "{ content: capacityHint, delay: { show: 400, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            class: _vm.datedInputClass(index, "capacity"),
                            attrs: {
                              type: "number",
                              min: "1",
                              max: "999",
                              step: "1",
                              placeholder: _vm.capacityPlaceholder,
                            },
                            domProps: { value: row.capacity },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(row, "capacity", $event.target.value)
                              },
                            },
                          }),
                        ]),
                        _c("feather-icon", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.auto",
                              value: {
                                content: _vm.$t("schedule.dates.remove"),
                                delay: { show: 300, hide: 100 },
                              },
                              expression:
                                "{ content: $t('schedule.dates.remove'), delay: { show: 300, hide: 100 } }",
                              modifiers: { auto: true },
                            },
                          ],
                          staticClass:
                            "cursor-pointer text-danger dates-row-remove",
                          attrs: { icon: "Trash2Icon", size: "18" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmRemoveDatedRow(index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.datedMessages(index).length
                      ? _c(
                          "ul",
                          { staticClass: "schedule-row-messages" },
                          _vm._l(
                            _vm.datedMessages(index),
                            function (message, msgIndex) {
                              return _c(
                                "li",
                                {
                                  key: "dmsg-" + row.uid + "-" + msgIndex,
                                  class:
                                    message.type === "error"
                                      ? "is-error"
                                      : "is-warning",
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-25",
                                    attrs: {
                                      icon:
                                        message.type === "error"
                                          ? "AlertCircleIcon"
                                          : "AlertTriangleIcon",
                                      size: "13",
                                    },
                                  }),
                                  _vm._v(" " + _vm._s(message.text) + " "),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm.dateRows.length
                ? _c("div", { staticClass: "dates-total" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("schedule.dates.total", {
                            n: _vm.dateRows.length,
                          })
                        ) +
                        " · " +
                        _vm._s(_vm.datedTotal) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "schedule-footer", class: { "is-dirty": _vm.isDirty } },
        [
          _c(
            "div",
            { staticClass: "schedule-footer-status" },
            [
              _vm.hasErrors
                ? [
                    _c("feather-icon", {
                      staticClass: "text-danger mr-50",
                      attrs: { icon: "AlertCircleIcon", size: "16" },
                    }),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.$t("schedule.grid.fix_errors"))),
                    ]),
                  ]
                : _vm.isDirty
                ? [
                    _c("feather-icon", {
                      staticClass: "text-warning mr-50",
                      attrs: { icon: "EditIcon", size: "16" },
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("schedule.grid.unsaved")) +
                          " " +
                          _vm._s(_vm.pendingLabel)
                      ),
                    ]),
                  ]
                : [
                    _c("feather-icon", {
                      staticClass: "text-success mr-50",
                      attrs: { icon: "CheckCircleIcon", size: "16" },
                    }),
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("schedule.grid.in_sync"))),
                    ]),
                  ],
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "schedule-footer-actions" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "outline-secondary",
                    size: "sm",
                    disabled: !_vm.isDirty || _vm.saving,
                  },
                  on: { click: _vm.confirmDiscard },
                },
                [_vm._v(" " + _vm._s(_vm.$t("schedule.grid.discard")) + " ")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "ml-1",
                  attrs: {
                    variant: "primary",
                    size: "sm",
                    disabled: !_vm.isDirty || _vm.hasErrors || _vm.saving,
                  },
                  on: { click: _vm.save },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "SaveIcon", size: "16" },
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("schedule.grid.save"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("schedule.grid.replicate_modal.title"),
            size: "md",
            centered: "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: {
                        click: function ($event) {
                          _vm.replicate.open = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("schedule.grid.replicate_modal.cancel")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled:
                          !_vm.replicate.source ||
                          _vm.replicate.targets.length === 0,
                      },
                      on: { click: _vm.applyReplicate },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("schedule.grid.replicate_modal.confirm")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.replicate.open,
            callback: function ($$v) {
              _vm.$set(_vm.replicate, "open", $$v)
            },
            expression: "replicate.open",
          },
        },
        [
          _vm.replicateSourceOptions.length === 0
            ? _c("p", { staticClass: "text-danger mb-0" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("schedule.grid.replicate_modal.no_source")) +
                    " "
                ),
              ])
            : [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("schedule.grid.replicate_modal.source"),
                    },
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.replicate.source,
                            expression: "replicate.source",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.replicate,
                              "source",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.replicateSourceOptions, function (option) {
                        return _c(
                          "option",
                          {
                            key: "src-" + option.day,
                            domProps: { value: option.day },
                          },
                          [_vm._v(" " + _vm._s(option.label) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("schedule.grid.replicate_modal.targets"),
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "replicate-quick" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("all")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("schedule.grid.replicate_modal.all")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("weekdays")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "schedule.grid.replicate_modal.weekdays"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("weekend")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "schedule.grid.replicate_modal.weekend"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("none")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("schedule.grid.replicate_modal.none")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "replicate-days" },
                      _vm._l(_vm.replicateTargetDays, function (day) {
                        return _c(
                          "label",
                          { key: "tgt-" + day, staticClass: "replicate-day" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked:
                                  _vm.replicate.targets.indexOf(day) !== -1,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleTarget(day)
                                },
                              },
                            }),
                            _c("span", [_vm._v(_vm._s(_vm.dayLong(day)))]),
                            _vm.isTargetFilled(day)
                              ? _c(
                                  "span",
                                  { staticClass: "replicate-day-tag" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "schedule.grid.replicate_modal.filled"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _c("label", { staticClass: "replicate-day" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.replicate.overwrite,
                        expression: "replicate.overwrite",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.replicate.overwrite)
                        ? _vm._i(_vm.replicate.overwrite, null) > -1
                        : _vm.replicate.overwrite,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.replicate.overwrite,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.replicate,
                                "overwrite",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.replicate,
                                "overwrite",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.replicate, "overwrite", $$c)
                        }
                      },
                    },
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("schedule.grid.replicate_modal.overwrite"))
                    ),
                  ]),
                ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }